/** Optional page background atmosphere — warm gradient + performance glow */
export function PageAtmosphere({ className = '', contained = false }) {
  return (
    <div
      className={[
        'pointer-events-none overflow-hidden',
        contained ? 'absolute inset-0 z-0' : 'fixed inset-0 -z-10',
        className,
      ].filter(Boolean).join(' ')}
      aria-hidden
    >
      <div className="absolute inset-0 bg-[var(--surface-page)] dark:bg-[var(--surface-page,#0B0B0D)]" />
      {/* Top-center brand wash */}
      <div
        className="landing-atmosphere-glow absolute -top-32 left-1/2 h-96 w-[32rem] -translate-x-1/2 rounded-full opacity-40 blur-3xl dark:opacity-25"
        style={{ background: 'var(--brand-glow)' }}
      />
      {/* Lower-right endurance glow */}
      <div
        className="landing-atmosphere-glow absolute -bottom-24 -right-16 h-80 w-80 rounded-full opacity-25 blur-3xl dark:opacity-15"
        style={{ background: 'color-mix(in srgb, var(--data-ftp) 35%, transparent)' }}
      />
      {/* Subtle vignette — cockpit depth, not flat SaaS canvas */}
      <div
        className="absolute inset-0 opacity-[0.04] dark:opacity-[0.12]"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 50% 0%, transparent 40%, rgba(28,25,23,0.55) 100%)',
        }}
      />
    </div>
  );
}
